import type { RefereeTrend } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

// The signed-in referee's own recent trend — daily activity (Study-streak sparkline) + weekly
// accuracy (Rule-accuracy sparkline) on Home. Scoped to the caller by their JWT.
export async function getMeTrend(): Promise<RefereeTrend> {
  const res = await api.get<Envelope<RefereeTrend>>('/me/trend');
  return unwrap(res.data);
}
